import { PRStatus } from '@eapproval/offer-shared'
import { Badge, Flex, Input, Select, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Tooltip } from '@chakra-ui/react'
import GCPRSubmission from '../GCPRSubmission'
import { getGCPRStatusBadgeColor } from '../../utils/GCPR.helper'

const GCPRSubmissionTabs = ({
  filteredSubmissions = [],
  tabIndex = 0,
  onTabIndexChange = () => {},
  tabSearch = '',
  onTabSearchChange = () => {},
  tabStatusFilter = '',
  onTabStatusFilterChange = () => {},
  onDeleteDraft = () => {},
}) => {
  return (
    <Tabs
      size="md"
      variant="enclosed"
      index={tabIndex}
      orientation="vertical"
      isLazy
      onChange={(index) => {
        onTabIndexChange(index)
      }}
      w="100%"
    >
      <TabList
        overflowX={'scroll'}
        overflowY={'hidden'}
        sx={{
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        minW="300px"
        flexDirection="column"
      >
        <Input
          placeholder="Search PR..."
          size="sm"
          value={tabSearch}
          onChange={(e) => onTabSearchChange(e.target.value)}
          mb={1}
        />
        <Select
          placeholder="All statuses"
          size="sm"
          value={tabStatusFilter}
          onChange={(e) => onTabStatusFilterChange(e.target.value)}
          mb={2}
        >
          {Object.values(PRStatus).map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </Select>
        {filteredSubmissions.map(({ submission, originalIndex }) => {
          const fullPRNumber = submission?.PRNumber ?? ''
          const displayName =
            fullPRNumber === ''
              ? `PR Submission ${originalIndex + 1}`
              : (fullPRNumber.match(/PR\d+(-S)?$/) ?? [fullPRNumber])[0]
          return (
            <Tab
              key={'GCPRSubmissionTab_' + originalIndex}
              as={Flex}
              gap={2}
              direction="column"
              alignItems={'start'}
              borderTopEndRadius={0}
              borderRight={'0'}
              _selected={{
                borderColor: 'teal.500',
                borderWidth: '2px',
              }}
            >
              <Flex w="100%" direction="column" gap={1}>
                <Tooltip label={fullPRNumber || displayName}>
                  <Text
                    textDecorationThickness={'3px'}
                    textDecorationColor={'teal.400'}
                    textUnderlineOffset={'5px'}
                    w={'100%'}
                    textOverflow={'hidden'}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                  >
                    {displayName}
                  </Text>
                </Tooltip>
                {submission.descriptionOfProduct && (
                  <Text
                    fontSize="xs"
                    color="gray.500"
                    w={'100%'}
                    textOverflow={'ellipsis'}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                  >
                    {submission.descriptionOfProduct}
                  </Text>
                )}
                <Badge colorScheme={getGCPRStatusBadgeColor(submission.status)} w="fit-content">
                  {submission.status}
                </Badge>
              </Flex>
            </Tab>
          )
        })}
      </TabList>

      <TabPanels id="offerGCPRSubmissionTabPanels">
        {filteredSubmissions.map(({ submission, originalIndex }) => (
          <TabPanel
            key={submission.id ?? originalIndex}
            border="1px solid rgb(226, 232, 240)"
            borderColor={''}
            overflowY={'auto'}
            w="calc(100% - 300px)"
            // w="100%"
          >
            <GCPRSubmission submissionIndex={originalIndex} handleDeleteDraft={() => onDeleteDraft(originalIndex)} />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  )
}

export default GCPRSubmissionTabs
